import { message } from 'antd';

export const message_error = value => message.error(value, 1.5);
export const message_warn = value => message.warning(value);
export const message_success = value => message.success(value, 1);
export const message_notification = value => message.success(value, 5);
export const message_info = value => message.info(value, 1);



// WEBPACK FOOTER //
// ./src/components/Message.js